import React, {useEffect, useRef, useState, useCallback} from "react";
import AlbumData from "./AlbumData";
// import redbook2 from "../../../assets/images/dummy/redbook2.png";
// import redbook1 from "../../../assets/images/dummy/redbook1.png";
import {useNavigate} from "react-router-dom";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {selectedSchool} from "../../../recoils/recoil";
// import {useRecoilValue, useSetRecoilState} from "recoil";
// import {selectedSchool} from "../../../recoils/recoil";
// import ReactModal from "react-modal";

const Album = () => {
    const selectedSchoolList = useRecoilValue(selectedSchool);
    const setSelectedSchoolList = useSetRecoilState(selectedSchool);
    const limit = 10;
    const [isLoading, setIsLoading] = useState(false);
    const [filteredDatas, setFilteredDatas] = useState([]);
    const [page, setPage] = useState(1);
    const [totalCnt, setTotalCnt] = useState(0);
    const [hasNextPage, setHasNextPage] = useState(true);
    const observerRef = useRef(null);
    const index = useRef(0);

    // 모바일 툴팁 관련
    const [isTooltipVisible, setTooltipVisible] = useState(false);
    const toolTipRef = useRef(null);
    const [datas, setDatas] = useState([]);
    const navigate = useNavigate();
    // const [isPopupOpen, setIsPopupOpen] = useState(false);
    // const [loading, setLoading] = useState(false);


    const getMoreData = useCallback(async () => {
        if (!hasNextPage) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        try {
            const startIndex = index.current;
            const endIndex = index.current + limit;
            const moreData = datas.slice(startIndex, endIndex);

            setFilteredDatas((prevData) => [...prevData, ...moreData]);
            index.current = endIndex;
            setPage((prevPage) => prevPage + 1);

            if (totalCnt <= index.current && totalCnt !== 0) {
                setHasNextPage(false);
            }
        } catch (error) {
            console.error(error.message);
        } finally {
            setIsLoading(false);
        }
    }, [hasNextPage, datas, totalCnt]);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const res = await fetchAllAlbumListData();

                const sortedData = Array.from(
                    // book_id 기준 중복된 데이터 제거
                    new Map(res.map(item => [item.book_id, item])).values()
                )
                    //publish_year 기준 오름차순 정렬, 연도 미상 데이터 최상단으로 노출
                    .sort((a, b) => {
                        if (a.publish_year === 0) return -1;
                        if (b.publish_year === 0) return 1;
                        return a.publish_year - b.publish_year;
                    })
                    //publish_year가 0인 경우 "연도 미상"으로 표기
                    .map(item => ({
                        ...item,
                        publish_year: item.publish_year === 0 ? "연도 미상" : item.publish_year
                    }));


                setDatas(sortedData);
                setTotalCnt(sortedData.length);
                const initialData = sortedData.slice(0, limit);
                setFilteredDatas(initialData);
                index.current = limit;
            } catch (error) {
                console.error(error.message);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();

        // 모바일 툴팁 외부 영역 클릭 시 툴팁 닫기
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const onIntersection = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && hasNextPage && !isLoading) {
                    getMoreData();
                }
            });
        };

        const observer = new IntersectionObserver(onIntersection);

        // ref 의 현재 값을 지역 변수로 저장
        const targetElement = observerRef.current;

        if (targetElement !== null) {
            observer.observe(targetElement);
        }

        return () => {
            if (targetElement) {
                observer.unobserve(targetElement); // 변경되지 않는 값 사용
            }
            observer.disconnect();
        };
    }, [hasNextPage, page, isLoading, getMoreData]);


    const fetchAllAlbumListData = async () => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(AlbumData);
            }, 500);
        });
    };

    const handleClickOutside = (e) => {
        if (toolTipRef.current && !toolTipRef.current.contains(e.target)) {
            setTooltipVisible(false);
        }
    };

    const handleSchoolClick = (order) => {
        const exists = selectedSchoolList.some(school => school.id === order.school_id);

        const updatedList = exists
            ? [...selectedSchoolList] // 기존 순서 유지
            : [...selectedSchoolList, { id: order.school_id, name: order.primaryname, nameKo: order.primaryname_ko }];

        setSelectedSchoolList(updatedList);

        const idList = updatedList.map(school => school.id);

        // 배열에 넣어서 personId 보내기
        navigate(`/school/${idList.join(',')}`);
    };

    // 상세 이동 함수
    const viewDetail = () => {
        // TODO: Detail page view logic

        navigate("/emptyPage")
    }

    return (
        <>
            <main id="contents">
                <div className="sub-content">
                    <div className="archive-wrap">
                        <div className="cont-top">
                            <div className="w-set">
                                <div className="title-wrap">
                                    <h2 className="title batang">졸업앨범 내 조선인 <br className="hide-pc"/> <span style={{fontSize: "0.8em"}}>(자료 준비중...)</span>
                                    </h2>
                                    <p className="text">일제강점기 중등 및 고등교육기관
                                        <br/>졸업앨범 입니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="cont-btm">
                            <div className="archive-text-box">
                                <div className="w-set">
                                    <div className="text-wrap">
                                        <p><strong>일제강점기 졸업앨범을 어떻게 찾을 수 있을까요?</strong></p>
                                        <p className="text">
                                            학교들은 일제강점기에도 졸업앨범을 제작했습니다. 센터는 대학, 전문학교, 사범학교, 실업학교를 비롯한 일제강점기 중등 및 고등교육기관
                                            47교의 졸업앨범을 수집하여 졸업생 정보를 정리하였습니다. 이 홈페이지는 졸업앨범에 기재된 조선인 졸업생 면당을 제공합니다. 우리는 이
                                            자료를 통해 어떠한 인물이 어느 학교 출신인지 확인할 수 있습니다.

                                        </p>
                                    </div>
                                    <div className="img-wrap">
                                        <div className="archive-slides">
                                            <ul className="slides-wrapper">
                                                <li>
                                                    <div className="imgbox"><img src="/images/archive/album_main.jpg"
                                                                                 alt="졸업앨범 표지_숙명고등여학교_제34회_졸업기념(1943)"/>
                                                    </div>
                                                    <p className="caption">숙명고등여학교제 34회 졸업기념 (1943)</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="list-wrap table-contents">
                                <div className="w-set">
                                    <div className="list-top">
                                        <strong>조선인 졸업자 목록</strong>
                                        <div className="tooltip-wrap" ref={toolTipRef}>
                                            <button type="button" className="i-tool"
                                                onClick={() => setTooltipVisible(!isTooltipVisible)}
                                            ></button>
                                            <div className={`tool-box ${isTooltipVisible ? 'on' : ''}`}>학교명 클릭 시 검색페이지로 이동합니다.</div>
                                        </div>
                                    </div>
                                    <div className="list-btm">
                                        <div className="table-wrap">
                                            <div className="scroll-table">
                                                {filteredDatas.map((data, idx) => (
                                                    <div key={idx} className="list-row">
                                                        <div className="row-link disabled" onClick={(e) => {
                                                            e.preventDefault();  // 기본 동작인 URL 변경을 방지
                                                                                // TODO 추후 팝업 불러오는 함수로 변경하기

                                                        }}>
                                                            <div className="date">{data.publish_year}</div>
                                                            <div className="title bold">
                                                                {data.book_title}
                                                                <span className="num">{data.publisher}</span>
                                                            </div>
                                                            <div className="school">
                                                                <button
                                                                    key={data.school_id}
                                                                    className="search-text"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation(); // 부모 div 클릭 이벤트(viewDetail) 실행 방지 - viewDetail 안 쓸 시에 삭제할것
                                                                        handleSchoolClick(data);
                                                                    }}
                                                                >
                                                                    {data.primaryname}
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div ref={observerRef}></div>
                                                    </div>
                                                ))}
                                                {isLoading && (
                                                    <div className="load-wrap type-full">
                                                        <div className="load-box">
                                                            <div className="square"></div>
                                                            <div className="square"></div>
                                                            <div className="square"></div>
                                                            <div className="square"></div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/*<ReactModal*/}
            {/*    isOpen={isPopupOpen}*/}
            {/*    onRequestClose={null}*/}
            {/*    contentLabel="Alumni Modal"*/}
            {/*    style={{*/}
            {/*        overlay: {*/}
            {/*            backgroundColor: "rgba(0, 0, 0, 0.5)",*/}
            {/*            zIndex: 1000,*/}
            {/*        },*/}
            {/*        content: {*/}
            {/*            inset: "unset",*/}
            {/*            padding: 0,*/}
            {/*            border: "none",*/}
            {/*            borderRadius: 0,*/}
            {/*            background: "transparent",*/}
            {/*            width: "auto",*/}
            {/*            height: "auto"*/}
            {/*        }*/}
            {/*    }}*/}
            {/*>*/}

            {/*    <div*/}
            {/*        className="wbz-popup-cont is-template"*/}
            {/*        id="doboViewPopup"*/}
            {/*        style={{*/}
            {/*            display: 'flex',*/}
            {/*            flexDirection: 'column',*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        <div className="popup-header">*/}
            {/*            <b className="popup-title">{selectedAlumni.book_title}</b>*/}
            {/*            <button type="button" className="popup-close" onClick={handleCloseModal1}>닫기</button>*/}
            {/*        </div>*/}
            {/*        <div className="popup-cont">*/}
            {/*            <div className="list-table">*/}
            {/*                {selectedAlumni.book_id && (*/}
            {/*                    <div className="list-wrap">*/}
            {/*                        <ul>*/}
            {/*                            {selectedAlumni.map((toc, index) => (*/}
            {/*                                <li key={toc.toc_id}>*/}
            {/*                                    <div*/}
            {/*                                        className="list-title">{toc.toc_title.includes("/") ? toc.toc_title.split("/")[1] : toc.toc_title}</div>*/}
            {/*                                    <ul className="list-cont">*/}
            {/*                                        {toc.orders.map((order, index) => (*/}
            {/*                                            <li className="list-item"*/}
            {/*                                                key={`${order.psnorders_id}_${index}`}>*/}
            {/*                                                {order.status_text ? ' ' : ''}*/}
            {/*                                                <button className="search-text"*/}
            {/*                                                        onClick={() => handleSchoolClick(order)}>{order.primaryname}</button>*/}
            {/*                                                {' '}{order.order_text}*/}
            {/*                                            </li>*/}
            {/*                                        ))}*/}
            {/*                                    </ul>*/}
            {/*                                </li>*/}
            {/*                            ))}*/}
            {/*                        </ul>*/}
            {/*                    </div>*/}
            {/*                )}*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</ReactModal>*/}
        </>
    );
};

export default Album;
